import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './DENTToothEndodonticIcon.module.scss';
import Tooltip from '../../../../Components/Popup/Tooltip';
import Text from '../../../../Components/Base/Text/Text';

interface EndodonticIconData {
	key: string;
	icon: {
		src: string;
		tooltip: string;
	};
}

interface Props {
	iconData: EndodonticIconData;
	reverse?: boolean;
}

const DENTToothEndodonticIconSingle = ({ iconData, reverse }: Props) => {
	const { key, icon } = iconData;

	return (
		<div
			className={joinClasses([styles.wrapper, reverse ? styles.reverse : ''])}>
			<div className={styles.icons}>
				<Tooltip
					position={'top center'}
					trigger={<img className={styles.icon} src={icon.src} alt={key} />}>
					<Text tx={icon?.tooltip} />
				</Tooltip>
			</div>
		</div>
	);
};

export default DENTToothEndodonticIconSingle;
